import { createContext, useContext } from "react";

type ImpactedGPCount = {
  count: number;
  setCount?: (count: number) => void;
};

export const ImpactedGPContext = createContext<ImpactedGPCount>({
  count: 0,
  setCount: () => {},
});

export const useImpactedGPContext = () => useContext<ImpactedGPCount>(ImpactedGPContext);
